import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import Position from "../models/Position";

class PositionService extends GenericCrudService<Position> {
 findByProjectExternalIdAndRoleKey(
    page: number,
    pageSize: number,
    projectExternalId: string,
    roleKey: string,
    positionStatus: boolean
  ): Promise<ApiResponse<PagedResult<Position>>> {
    let query = `${this.basePath}/find-filtered?page=${page}&pageSize=${pageSize}&projectExternalId=${projectExternalId}&roleKey=${roleKey}&positionStatus=${positionStatus}`;
    return HttpClient.get(query, true);
  }

  findPositionNamesByProjectId(projectExternalId: string): Promise<ApiResponse<AutoCompleteUIDTO[]>> {
    return HttpClient.get(`${this.basePath}/position-names?projectExternalId=${projectExternalId}`);
  }

  findProjectUserListFromManager(): Promise<ApiResponse<AutoCompleteUIDTO[]>> {
    return HttpClient.get(`${this.basePath}/assigned-to`);
  }

  findPositionByExternalId(externalId: string): Promise<ApiResponse<Position>> {
    return HttpClient.get(`${this.basePath}/${externalId}`, true);
  }
}

export default new PositionService("/ensolvers-ops/positions");
